<template>
    <div class="professional-application-file-field" :class="{ 'professional-application-file-field--makeup': tone === 'makeup' }">
        <span class="professional-application-file-field__label">{{ label }} <b v-if="required">*</b></span>
        <label class="professional-application-file-field__picker">
            <strong v-if="file">{{ file.name }}</strong>
            <span v-else class="professional-application-file-field__add">
                <i aria-hidden="true">+</i>
                <em>选择文件</em>
            </span>
            <input type="file" :accept="accept" @change="$emit('select', $event)" />
            <button
                v-if="file"
                type="button"
                class="professional-application-file-field__remove"
                aria-label="删除已上传文件"
                title="删除文件"
                @click.stop.prevent="$emit('remove')">
                <i class="el-icon-delete" aria-hidden="true"></i>
            </button>
        </label>
        <small class="professional-application-file-field__hint">{{ hint }}</small>
    </div>
</template>

<script>
export default {
    name: "ProfessionalApplicationFileField",
    props: {
        label: { type: String, required: true },
        accept: { type: String, required: true },
        file: { type: Object, default: null },
        hint: { type: String, default: "支持对应格式，单个最大 5 MiB。" },
        tone: { type: String, default: "photographer" },
        required: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.professional-application-file-field { display: grid; gap: 6px; min-width: 0; color: #5e5763; }
.professional-application-file-field__label { font-size: 11px; font-weight: 800; }
.professional-application-file-field__label b { color: #dc657f; }
.professional-application-file-field__picker { position: relative; display: grid; min-width: 0; gap: 5px; min-height: 54px; padding: 10px 44px 10px 10px; background: #fbfdfe; border: 1px dashed #bad5e2; border-radius: 10px; cursor: pointer; }
.professional-application-file-field__picker strong { overflow: hidden; color: #4681a0; font-size: 10px; font-weight: 600; line-height: 1.5; text-overflow: ellipsis; white-space: nowrap; }
.professional-application-file-field__add { display: inline-flex; align-items: center; gap: 7px; color: #9a929d; font-size: 10px; font-style: normal; }
.professional-application-file-field__add i { display: grid; width: 26px; height: 26px; place-items: center; color: #4f90ae; background: #fff; border: 1px solid #bad8e6; border-radius: 7px; font-size: 20px; font-style: normal; font-weight: 400; line-height: 1; }
.professional-application-file-field__add em { font-style: normal; }
.professional-application-file-field__picker input { display: none; }
.professional-application-file-field__remove { position: absolute; top: 50%; right: 10px; display: grid; width: 26px; height: 26px; place-items: center; padding: 0; color: #a1495c; background: transparent; border: 0; border-radius: 50%; cursor: pointer; font-size: 16px; transform: translateY(-50%); }
.professional-application-file-field__remove:hover { color: #d56886; background: #fff1f3; }
.professional-application-file-field__remove:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
.professional-application-file-field__hint { color: #857f76; font-size: 10px; font-weight: 400; line-height: 1.5; }
.professional-application-file-field--makeup .professional-application-file-field__picker { background: #fffafb; border-color: #e7b8c6; }
.professional-application-file-field--makeup .professional-application-file-field__picker strong { color: #a85b73; }
.professional-application-file-field--makeup .professional-application-file-field__add i { color: #c55d78; border-color: #edbdc9; }
.professional-application-file-field--makeup .professional-application-file-field__remove:hover { color: #c55d78; background: #fff1f4; }
</style>
